import React from 'react';
import { UsuarioLogadoContext } from './UsuarioLogadoContext';

export default function UsuarioLogadoConsumer({ children, ...rest }) {
  return (
    <UsuarioLogadoContext.Consumer>
      {({
        usuarioLogado,
        usuarioGerente,
        usuarioAdmin,
        exibeIndicadores,
        usuarioInterno,
        usuarioConsultorExterno,
        exibeRoteirizacao,
      }) =>
        React.Children.map(children, child =>
          React.cloneElement(child, {
            usuarioLogado,
            usuarioGerente,
            exibeIndicadores,
            usuarioInterno,
            usuarioAdmin,
            usuarioConsultorExterno,
            exibeRoteirizacao,
            ...rest,
          })
        )
      }
    </UsuarioLogadoContext.Consumer>
  );
}
